export enum SSNErrorType {
  BLOCKED_SSN = `blockedSSN`,
  INVALID_SSN = `invalidSSN`,
  FrozenBUREAU = 'frozenBureauExists',
}

export interface SSNError {
  message: string;
  type: string;
}
